export const errorPrefix = (prefix: string, error: Error) => {
  error.message = `${prefix} ${error.message}`;

  return error;
};
